import { CanvasHtml } from "@dinahmoe/dmafjs-visual";
import { bridge } from "@dinahmoe/dmafjs-core";
// import GUI from "lil-gui";

class StarryConnectEnvironment extends CanvasHtml {
  setProps(node) {
    super.setProps(node);

    const canvas = node.element;
    const ctx = canvas.getContext('2d');

    canvas.width = 1920;
    canvas.height = 1080;
    canvas.style.cursor = 'crosshair';
    canvas.style.pointerEvents = 'auto';

    // Configuration object (now mutable for GUI)
    const config = {
      parallaxStrength: 50,
      numStars: 200,
      starRadius: 50,
      hoverRadius: 100,
      centerDensityStrength: 2,
      smoothing: 0.3,
      lineSpeed: 0.2,
      rectangleDelay: 1500,
      rectangleProbability: 0.15,
      rectangleSpread: 1,
      shrinkDelay: 100,
      floatAmplitude: 10,
      starBaseSize: 3,
      starGrowthFactor: 1.5,
      starGrowDuration: 1000,
      starDecayDuration: 5000,
      lineWidth: 0.8,
      easingPower: 5,
      glowStrength: 0,
      glowSize: 5,
      glowEasingPower: 1
    };

    // Create GUI
    // const gui = new GUI();
    // gui.add(config, 'parallaxStrength', 0, 100).name('Parallax Strength');
    // gui.add(config, 'numStars', 5, 500, 1).name('Number of Stars').onChange(() => {
    //   regenerateStars();
    // });
    // gui.add(config, 'starRadius', 5, 50).name('Star Radius');
    // gui.add(config, 'hoverRadius', 5, 100).name('Hover Radius');
    // gui.add(config, 'centerDensityStrength', 1, 3).name('Center Density').onChange(() => {
    //   applyDensity();
    // });
    // gui.add(config, 'smoothing', 0.01, 0.5).name('Mouse Smoothing');
    // gui.add(config, 'lineSpeed', 0.05, 1).name('Line Speed (px/ms)');

    // gui.add(config, 'rectangleDelay', 0, 4000).name('Rectangle Delay (ms)');
    // gui.add(config, 'rectangleProbability', 0, 1).name('Rectangle Probability');
    // gui.add(config, 'rectangleSpread', 0, 1).name('Rectangle Time Spread');
    // gui.add(config, 'shrinkDelay', 0, 4000).name('Shrink Delay (ms)');
    // gui.add(config, 'floatAmplitude', 0, 20).name('Float Amplitude');
    // gui.add(config, 'starBaseSize', 0.5, 10).name('Star Base Size');
    // gui.add(config, 'starGrowthFactor', 1, 2).name('Star Growth Factor');
    // gui.add(config, 'starGrowDuration', 50, 1000).name('Star Grow Duration (ms)');
    // gui.add(config, 'starDecayDuration', 5000, 20000).name('Star Decay Duration (ms)');
    // gui.add(config, 'lineWidth', 0.5, 2).name('Line Width');
    // gui.add(config, 'easingPower', 1, 5, 0.1).name('Easing Power');
    // gui.add(config, 'glowStrength', 0, 2).name('Glow Strength');
    // gui.add(config, 'glowSize', 5, 30).name('Glow Size');
    // gui.add(config, 'glowEasingPower', 1, 5, 0.1).name('Glow Easing Power');

    // node._gui = gui;

    // Generate stars with better distribution
    let stars = [];

    const regenerateStars = () => {
      stars = [];

      // Create grid with heavy jitter to break up pattern
      const gridCols = Math.ceil(Math.sqrt(config.numStars));
      const gridRows = Math.ceil(config.numStars / gridCols);
      const cellWidth = canvas.width / gridCols;
      const cellHeight = canvas.height / gridRows;

      for (let i = 0; i < config.numStars; i++) {
        const gridX = i % gridCols;
        const gridY = Math.floor(i / gridCols);

        // Heavy jitter - randomize almost entire cell to break grid pattern
        const baseX = gridX * cellWidth + (Math.random() * cellWidth);
        const baseY = gridY * cellHeight + (Math.random() * cellHeight);

        const depth = Math.random() * 0.6 + 0.4;
        stars.push({
          baseX: baseX,  // Store original position
          baseY: baseY,
          x: baseX,      // Current position (will be transformed)
          y: baseY,
          baseSize: config.starBaseSize,
          depth: depth,
          floatOffsetX: Math.random() * Math.PI * 2,
          floatOffsetY: Math.random() * Math.PI * 2,
          floatSpeedX: 0.8 + Math.random() * 0.4,
          floatSpeedY: 0.8 + Math.random() * 0.4,
          lastTriggeredAt: null,
          animationStartSize: null,
          targetSize: null
        });
      }

      // Apply initial density
      applyDensity();
    };

    const applyDensity = () => {
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const maxRadius = Math.sqrt(centerX * centerX + centerY * centerY);

      stars.forEach(star => {
        let x = star.baseX;
        let y = star.baseY;

        // Apply center density scaling
        if (config.centerDensityStrength > 1) {
          // Convert to center-based coordinates
          const relX = x - centerX;
          const relY = y - centerY;

          // Calculate distance and angle from center
          const r = Math.sqrt(relX * relX + relY * relY);
          const angle = Math.atan2(relY, relX);

          // Normalize radius (0-1)
          const normalizedR = r / maxRadius;

          // Calculate falloff: 1 at center, 0 at edge
          const falloff = 1 - normalizedR;

          // Variable exponent: density at center, 1 at edge
          const exponent = 1 + (config.centerDensityStrength - 1) * falloff;

          // Apply transformation
          const newNormalizedR = Math.pow(normalizedR, exponent);
          const newR = newNormalizedR * maxRadius;

          // Convert back to cartesian
          x = centerX + newR * Math.cos(angle);
          y = centerY + newR * Math.sin(angle);
        }

        star.x = x;
        star.y = y;
      });
    };

    regenerateStars();

    // State
    let mouseX = canvas.width / 2;
    let mouseY = canvas.height / 2;
    let smoothMouseX = canvas.width / 2;
    let smoothMouseY = canvas.height / 2;
    let time = 0;
    let hoveredStar = null;
    let lastTriggeredStar = null;
    const lines = [];

    // Helper functions
    const easeIn = (t) => Math.pow(t, config.easingPower);

    const getParallaxOffset = (star) => {
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const offsetX = (smoothMouseX - centerX) / canvas.width * config.parallaxStrength * star.depth;
      const offsetY = (smoothMouseY - centerY) / canvas.height * config.parallaxStrength * star.depth;
      return { x: offsetX, y: offsetY };
    };

    const getStarPosition = (star) => {
      const offset = getParallaxOffset(star);
      const floatX = Math.sin(time * star.floatSpeedX + star.floatOffsetX) * config.floatAmplitude;
      const floatY = Math.sin(time * star.floatSpeedY + star.floatOffsetY) * config.floatAmplitude;
      return {
        x: star.x + offset.x + floatX,
        y: star.y + offset.y + floatY
      };
    };

    const drawStars = () => {
      const now = Date.now();

      stars.forEach(star => {
        const pos = getStarPosition(star);

        // Calculate size based on trigger time
        const baseSize = star.baseSize * star.depth;
        let size = baseSize;

        if (star.lastTriggeredAt !== null) {
          const elapsed = now - star.lastTriggeredAt;
          const totalDuration = config.starGrowDuration + config.starDecayDuration;

          if (elapsed < config.starGrowDuration) {
            // Growing phase - grow from start size to target size
            const growProgress = elapsed / config.starGrowDuration;
            size = star.animationStartSize + (star.targetSize - star.animationStartSize) * growProgress;
          } else if (elapsed < totalDuration) {
            // Decay phase - slow shrink from target size back to base
            const decayElapsed = elapsed - config.starGrowDuration;
            const decayProgress = decayElapsed / config.starDecayDuration;
            size = star.targetSize - (star.targetSize - baseSize) * decayProgress;
          } else {
            // Animation complete, reset trigger
            star.lastTriggeredAt = null;
            star.animationStartSize = null;
            star.targetSize = null;
            size = baseSize;
          }
        }
        const opacity = 0.4 + star.depth * 0.6;

        // Draw glow (skip if glowStrength is 0)
        if (config.glowStrength > 0) {
          const glowSize = size * config.glowSize;
          const glowGradient = ctx.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, glowSize);

          const numStops = 20;
          for (let i = 0; i <= numStops; i++) {
            const position = i / numStops;
            const easedOpacity = Math.pow(1 - position, config.glowEasingPower);
            glowGradient.addColorStop(position, `rgba(255, 255, 255, ${opacity * easedOpacity * config.glowStrength})`);
          }

          ctx.fillStyle = glowGradient;
          ctx.beginPath();
          ctx.arc(pos.x, pos.y, glowSize, 0, Math.PI * 2);
          ctx.fill();
        }

        // Draw star core
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, size, 0, Math.PI * 2);
        ctx.fillStyle = '#ffffff';
        ctx.fill();
      });
    };

    const drawLines = () => {
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = config.lineWidth;

      const now = Date.now();

      for (let i = lines.length - 1; i >= 0; i--) {
        const line = lines[i];
        const elapsed = now - line.createdAt;

        const fromPos = getStarPosition(line.from);
        const toPos = getStarPosition(line.to);

        let startX, startY, endX, endY;
        let drawRectangle = false;
        let rectangleProgress = 0;

        // Calculate duration based on distance and speed
        const growDuration = line.distance / config.lineSpeed;
        const lineRectangleDelay = config.rectangleDelay * line.spreadFactor;
        const rectangleStartTime = lineRectangleDelay;
        const rectangleEndTime = rectangleStartTime + growDuration;
        const shrinkStartTime = rectangleEndTime + config.shrinkDelay;
        const shrinkEndTime = shrinkStartTime + growDuration;

        // Growing phase
        if (elapsed < growDuration) {
          const progress = elapsed / growDuration;
          startX = fromPos.x;
          startY = fromPos.y;
          endX = fromPos.x + (toPos.x - fromPos.x) * progress;
          endY = fromPos.y + (toPos.y - fromPos.y) * progress;
        }
        // Shrinking phase
        else if (elapsed >= shrinkStartTime) {
          const shrinkElapsed = elapsed - shrinkStartTime;
          if (shrinkElapsed > growDuration) {
            lines.splice(i, 1);
            continue;
          }
          const progress = shrinkElapsed / growDuration;
          startX = fromPos.x + (toPos.x - fromPos.x) * progress;
          startY = fromPos.y + (toPos.y - fromPos.y) * progress;
          endX = toPos.x;
          endY = toPos.y;
        }
        // Full line visible
        else {
          startX = fromPos.x;
          startY = fromPos.y;
          endX = toPos.x;
          endY = toPos.y;
        }

        // Check rectangle independently (can happen during any line phase)
        if (elapsed >= rectangleStartTime && elapsed < rectangleEndTime) {
          drawRectangle = true;
          const rawProgress = (elapsed - rectangleStartTime) / growDuration;
          rectangleProgress = rawProgress;
        }

        // Draw line
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.stroke();

        // Draw rectangle
        if (drawRectangle && line.hasRectangle) {
          const rectX = fromPos.x + (toPos.x - fromPos.x) * rectangleProgress;
          const rectY = fromPos.y + (toPos.y - fromPos.y) * rectangleProgress;

          // Calculate angle of the line for rectangle orientation
          const angle = Math.atan2(toPos.y - fromPos.y, toPos.x - fromPos.x);

          // Draw glow
          const glowGradient = ctx.createRadialGradient(rectX, rectY, 0, rectX, rectY, 15);
          glowGradient.addColorStop(0, 'rgba(255, 255, 255, 0.8)');
          glowGradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.4)');
          glowGradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

          ctx.fillStyle = glowGradient;
          ctx.beginPath();
          ctx.arc(rectX, rectY, 15, 0, Math.PI * 2);
          ctx.fill();

          // Draw rectangle (elongated along the line)
          ctx.save();
          ctx.translate(rectX, rectY);
          ctx.rotate(angle);
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(-8, -3, 16, 6);
          ctx.restore();
        }
      }
    };

    const getHoveredStar = (checkX, checkY) => {
      let closestStar = null;
      let closestDistance = config.hoverRadius;

      for (let star of stars) {
        const pos = getStarPosition(star);
        const dx = checkX - pos.x;
        const dy = checkY - pos.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestStar = star;
        }
      }
      return closestStar;
    };

    const findClosestStars = (sourceStar, count) => {
      const sourcePos = getStarPosition(sourceStar);

      // Calculate distances to all other stars
      const starsWithDistance = stars
        .filter(star => star !== sourceStar)
        .map(star => {
          const pos = getStarPosition(star);
          const dx = pos.x - sourcePos.x;
          const dy = pos.y - sourcePos.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          return { star, distance };
        });

      // Sort by distance and take the closest N
      starsWithDistance.sort((a, b) => a.distance - b.distance);

      return starsWithDistance.slice(0, count).map(item => item.star);
    };

    const render = () => {
      if (node._isPaused) {
        node._animationFrameId = requestAnimationFrame(render);
        return;
      }

      // Smooth mouse position
      smoothMouseX += (mouseX - smoothMouseX) * config.smoothing;
      smoothMouseY += (mouseY - smoothMouseY) * config.smoothing;

      // Increment time
      time += 0.02;

      // Clear canvas (transparent)
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      drawLines();
      drawStars();

      node._animationFrameId = requestAnimationFrame(render);
    };

    // Mouse move handler
    const handleMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const clientX = e.clientX - rect.left;
      const clientY = e.clientY - rect.top;

      // Scale from display size to canvas internal resolution
      mouseX = (clientX / rect.width) * canvas.width;
      mouseY = (clientY / rect.height) * canvas.height;

      const newHoveredStar = getHoveredStar(mouseX, mouseY);

      // Only trigger if hovering a new star AND it's different from the last triggered star
      if (newHoveredStar && newHoveredStar !== hoveredStar && newHoveredStar !== lastTriggeredStar) {
        const now = Date.now();
        const closestStars = findClosestStars(newHoveredStar, 5);

        // Calculate current size at the moment of hover
        const baseSize = newHoveredStar.baseSize * newHoveredStar.depth;
        let currentSize = baseSize;

        if (newHoveredStar.lastTriggeredAt !== null) {
          const elapsed = now - newHoveredStar.lastTriggeredAt;
          const totalDuration = config.starGrowDuration + config.starDecayDuration;

          if (elapsed < config.starGrowDuration) {
            // Currently growing
            const growProgress = elapsed / config.starGrowDuration;
            currentSize = newHoveredStar.animationStartSize + (newHoveredStar.targetSize - newHoveredStar.animationStartSize) * growProgress;
          } else if (elapsed < totalDuration) {
            // Currently decaying
            const decayElapsed = elapsed - config.starGrowDuration;
            const decayProgress = decayElapsed / config.starDecayDuration;
            currentSize = newHoveredStar.targetSize - (newHoveredStar.targetSize - baseSize) * decayProgress;
          }
        }

        // Store current size as start, multiply by growth factor for target
        newHoveredStar.animationStartSize = currentSize;
        newHoveredStar.targetSize = currentSize * config.starGrowthFactor;

        // Set trigger timestamp on the hovered star
        newHoveredStar.lastTriggeredAt = now;

        closestStars.forEach(targetStar => {
          const fromPos = getStarPosition(newHoveredStar);
          const toPos = getStarPosition(targetStar);
          const dx = toPos.x - fromPos.x;
          const dy = toPos.y - fromPos.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          lines.push({
            from: newHoveredStar,
            to: targetStar,
            createdAt: now,
            distance: distance,
            hasRectangle: Math.random() < config.rectangleProbability,
            spreadFactor: 1 + (Math.random() * 2 - 1) * config.rectangleSpread
          });
        });

        // Update lastTriggeredStar - this star has now triggered
        lastTriggeredStar = newHoveredStar;

        bridge.update({ uid: node.uid, key: "starTriggered", sender: "browser" });
      }

      hoveredStar = newHoveredStar;
    };

    canvas.addEventListener('mousemove', handleMouseMove);

    // Store cleanup reference
    node._cleanupMouseMove = () => {
      canvas.removeEventListener('mousemove', handleMouseMove);
    };

    // Pause when off-screen
    node._isPaused = false;
    const observer = new IntersectionObserver(([entry]) => {
      node._isPaused = !entry.isIntersecting;
    }, { threshold: 0 });
    observer.observe(canvas);
    node._intersectionObserver = observer;

    // Start rendering
    render();
  }

  destroy(node) {
    if (node._intersectionObserver) {
      node._intersectionObserver.disconnect();
      node._intersectionObserver = null;
    }

    if (node._cleanupMouseMove) {
      node._cleanupMouseMove();
      node._cleanupMouseMove = null;
    }

    if (node._animationFrameId) {
      cancelAnimationFrame(node._animationFrameId);
      node._animationFrameId = null;
    }

    // if (node._gui) {
    //   node._gui.destroy();
    //   node._gui = null;
    // }

    super.destroy(node);
  }
}

const starryConnectEnvironment = new StarryConnectEnvironment(
  "visual:starry-connect"
);
export { StarryConnectEnvironment, starryConnectEnvironment };
